import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { ConfirmSwitchersChangeDialogContent } from './ConfirmSwitchersChangeDialogContent'

interface IProps {
  isShowDialog: boolean
  currCurrency: string
  currActualsValueType: string
  currency: string
  actualsValueType: string
  onConfirm: () => void
  onClose: () => void
}

export const ConfirmSwitchersChangeDialog = ({
  isShowDialog,
  currCurrency,
  currActualsValueType,
  currency,
  actualsValueType,
  onConfirm,
  onClose,
}: IProps) => {
  const contentProps = useMemo(() => {
    return { currCurrency, currActualsValueType, currency, actualsValueType, onConfirm, onClose }
  }, [currCurrency, currActualsValueType, currency, actualsValueType, onConfirm, onClose])

  return (
    <ModalDialog
      size={'xs'}
      show={isShowDialog}
      content={ConfirmSwitchersChangeDialogContent}
      contentProps={contentProps}
      onClose={onClose}
    />
  )
}
